import { InvoiceBillingTypeDataType } from '@/types'

export const enum InvoiceBillingTypeEnum {
    INVOICE = 'Invoice',
    CREDIT_MEMO = 'Credit Memo'
}

export const INVOICE_BILLING_TYPES: InvoiceBillingTypeDataType[] = [
    {
        key: InvoiceBillingTypeEnum.INVOICE,
        title: 'Invoice'
    },
    {
        key: InvoiceBillingTypeEnum.CREDIT_MEMO,
        title: 'Credit Memo'
    }
]
